import request, { mock } from '@/_util/require';
let version = 'v1';

// 查询对应sheet的数据
export async function gettaskplanexcellist(params) {
  return request(`/${version}/waper/erp/pc/task/gettaskplanexcellist`, {
    method: 'GET',
    params,
  });
}
// 分页查sheet页
export async function gettaskplanexcelsheetpage(params) {
  return request(`/${version}/waper/erp/pc/task/gettaskplanexcelsheetpage`, {
    method: 'POST',
    data: params,
  });
}

// 新增修改sheet
export async function saveupdatetaskplanexcelsheet(params) {
  return request(`/${version}/waper/erp/pc/task/saveupdatetaskplanexcelsheet`, {
    method: 'POST',
    data: params,
  });
}

// 新增|修改任务排期数据
export async function saveupdatetaskplanexcel(params) {
  return request(`/${version}/waper/erp/pc/task/saveupdatetaskplanexcel`, {
    method: 'POST',
    data: params,
  });
}

// 删除任务排期数据
export async function deletetask(params) {
  return request(`/${version}/waper/erp/pc/task/deletetask`, {
    method: 'GET',
    params,
  });
}

// 移除任务排期数据
export async function deletetaskplanexceldata(params) {
  return request(`/${version}/waper/erp/pc/task/deletetaskplanexceldata`, {
    method: 'POST',
    data: params,
  });
}

// 查询对应sheet的数据(废弃)
export async function deletetaskplanexcelsheet(params) {
  return request(`/${version}/waper/erp/pc/task/deletetaskplanexcelsheet`, {
    method: 'GET',
    params,
  });
}
export async function removetaskplanexceldata(params) {
  return request(`/${version}/waper/erp/pc/task/removetaskplanexceldata`, {
    method: 'POST',
    data: params,
  });
}

// 复制sheet（废弃）
export async function copytaskplanexcelsheet(params) {
  return request(`/${version}/waper/erp/pc/task/copytaskplanexcelsheet`, {
    method: 'POST',
    data: params,
  });
}
// 复制sheet
export async function copytaskplanexcelsheetnew(params) {
  return request(`/${version}/waper/erp/pc/task/copytaskplanexcelsheetnew`, {
    method: 'POST',
    data: params,
  });
}

// 获取可关联的任务列表
export async function gettorelataskplanpageexcel(params) {
  return request(`/${version}/waper/erp/pc/task/gettorelataskplanpageexcel`, {
    method: 'POST',
    data: params,
  });
}

// 复制任务行
export async function copytaskplanexcelrow(params) {
  return request(`/${version}/waper/erp/pc/task/copytaskplanexcelrow`, {
    method: 'POST',
    data: params,
  });
}

// 移动任务行
export async function movetaskplanexcelrow(params) {
  return request(`/${version}/waper/erp/pc/task/movetaskplanexcelrow`, {
    method: 'POST',
    data: params,
  });
}

// 引用任务行
export async function refertaskplanexcelrow(params) {
  return request(`/${version}/waper/erp/pc/task/refertaskplanexcelrow`, {
    method: 'POST',
    data: params,
  });
}

// 导出任务排期Excel
export const exporttaskplandata = `/${version}/waper/erp/pc/task/exporttaskplandata`;
